import type { FlagEvaluationOptions } from '@openfeature/web-sdk';
import { getFlag as getOpenFeatureFlag } from '../../../openfeature/client';
import type { FlagKey, FlagValue } from '../types';
import { getConfidenceOverrides } from '../development-tools/ConfidenceOverridesProvider';
import { openFeatureTypeToValue } from '../development-tools/utils';
import { isSupportedFlagType } from '../development-tools/utils/open-feature-type-to-value';

export function getFlag<K extends FlagKey>(
  key: K,
  defaultFlagValue: FlagValue<K>,
  options?: FlagEvaluationOptions,
) {
  const [result, type] = getOpenFeatureFlag(key, defaultFlagValue, options);
  const overrides = getConfidenceOverrides();

  if (key in overrides) {
    const confidenceOverride = overrides[key];

    if (!isSupportedFlagType(type)) {
      throw new Error(`Unsupported flag type: ${type}`);
    }

    return {
      value: openFeatureTypeToValue(confidenceOverride, type) as FlagValue<K>,
    };
  }

  return { value: result.value };
}
